import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    PROFILE_STATUS_PENDINGQUALIFICATION,
    PROFILE_STATUS_QUALIFIED,
    PROFILE_STATUS_REJECTED,
    PERMISSION_TALENTS_PROFILE_DIRECTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_TRANSLATOR_WRITE,
    PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_SINGER_WRITE,
    PERMISSION_TALENTS_PROFILE_ADAPTOR_WRITE,
    PERMISSION_TALENTS_PROFILE_LYRICIST_WRITE,
    PERMISSION_TALENTS_PROFILE_EDITOR_WRITE,
    PERMISSION_TALENTS_PROFILE_SOUNDENGINEER_WRITE,
    PERMISSION_TALENTS_PROFILE_BOOKER_WRITE
  } from '../../../../constants'
import QualifyPopup from './QualifyPopup'
import RejectPopup from './RejectPopup'
import RequestTestsOrSamplesPopup from './RequestTestsOrSamplesPopup'
import ProtectedElement from '../../../common/helpers/ProtectedElement'

class ProfileActions extends Component {
    getPermissionsToCheck(profileData) {
      switch (profileData.ProfileType) {
        case 'Director':
          return PERMISSION_TALENTS_PROFILE_DIRECTOR_WRITE;
        case 'Translator':
          return PERMISSION_TALENTS_PROFILE_TRANSLATOR_WRITE;
        case 'VoiceActor':
          return PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE;
        case 'Singer':
          return PERMISSION_TALENTS_PROFILE_SINGER_WRITE;
        case 'Adaptor':
          return PERMISSION_TALENTS_PROFILE_ADAPTOR_WRITE;
        case 'Lyricist':
          return PERMISSION_TALENTS_PROFILE_LYRICIST_WRITE;
        case 'Editor':
          return PERMISSION_TALENTS_PROFILE_EDITOR_WRITE;
        case 'SoundEngineer':
          return PERMISSION_TALENTS_PROFILE_SOUNDENGINEER_WRITE;
        case 'Booker':
          return PERMISSION_TALENTS_PROFILE_BOOKER_WRITE;
        default:
          return null;
      }
    }

    render() {
        let profileData = this.props.profileData;

        let permissionToCheck = this.getPermissionsToCheck(profileData);
        
        if (!permissionToCheck) {
          return null;
        }

        return (
          <ProtectedElement permission={permissionToCheck}>
            <div className="row">
              <div className="col-6"></div>
              <div className="col-6 text-right">
                {(profileData.Status === PROFILE_STATUS_PENDINGQUALIFICATION
                  || profileData.Status === PROFILE_STATUS_QUALIFIED
                  || profileData.Status === PROFILE_STATUS_REJECTED) &&
                  <QualifyPopup />
                }
                {profileData.Status === PROFILE_STATUS_PENDINGQUALIFICATION &&
                  <div style={{display: 'inline-block'}}>
                    <RejectPopup />
                    <RequestTestsOrSamplesPopup />
                  </div>
                }
              </div>
            </div>
          </ProtectedElement>
        );
    }
}

const mapStateToProps = (state) => ({
    profileData: state.skillVendorPage.currentProfile
  })
export default connect(mapStateToProps)(ProfileActions)